<template>
  <div class="_nav">
    <div class="_nav_content">
      <div class="_logo fl">
        <img src="../../assets/img/_logo.png" alt="">
      </div>
      <div class="_nav_right fl">
        <ul class="clearfix_">
          <li @mouseenter="enter(index)" @mouseleave="leave(index)" class="fl clearfix_" :class="{_nav_right_active:index==idx_}" v-for="(item,index) in navList" :key="index">
						<router-link tag="a" target="_blank" :to="{name:item.link}">{{item.title}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'member-header',
    data(){
      return {
        navList:[{title:'首页',link:'member'},{title:'积分商城',link:'scoreChange'}],
			  img_:true,
        idx_:0,
      }
    },
    methods:{
      enter:function(idx){
        var t_=this
        t_.idx_=idx
        if(idx==1){
          t_.img_=false
        }
      },
      leave(idx){
        var t_=this
        if(idx==1){
          t_.img_=true
        }
      }
    }
  }
</script>

<style>
  ._nav{
		width: 100%;
		height: 60px;
		background: #e2231a;
	}
	._nav_content{
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		overflow: hidden;
	}
	._logo{
		width: 160px;
		height: 70px;
		text-align: center;
	}
	._logo img{
		height: 70px;
		margin-top:-5px;
	}
	._nav_right{
		width: 920px;
		height: 60px;
		padding-left: 120px;
	}
	._nav_right li{
		height: 60px;
		line-height: 60px;
		color:#fff;
		font-size: 14px;
		margin-right: 40px;
		cursor: pointer;
	}
	._nav_right_active{
		background: url(../../assets/img/Arrow_top.png) no-repeat center 41px;
	}
	._nav_right li img{
		width: 16px;
		height: 16px;
		margin-top:21px;
	}
</style>



// WEBPACK FOOTER //
// src/components/member/member_header.vue